import { FormControl, MenuItem, Select } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";

import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { type CoordinateUnit } from "@/shared/state/visualization/schema/v1";

import styles from "./CoordinateUnitSelect.module.css";

interface CoordinateUnitSelectProps {
  /**
   * The type of coordinate (latitude or longitude) for the label
   */
  coordinateType: "latitude" | "longitude";
  /**
   * The current value of the select
   */
  value: CoordinateUnit | "";
  /**
   * Callback when the value changes
   */
  onChange: (event: SelectChangeEvent<CoordinateUnit | "">) => void;
  /**
   * Optional onBlur handler (for react-hook-form integration)
   */
  onBlur?: () => void;
  /**
   * Optional name attribute (for react-hook-form integration)
   */
  name?: string;
}

export function CoordinateUnitSelect({
  coordinateType,
  value,
  onChange,
  onBlur,
  name,
}: CoordinateUnitSelectProps) {
  const label =
    coordinateType === "latitude" ? "Latitude unit" : "Longitude unit";

  return (
    <div className={styles.unitSelector}>
      <RobotoTypography
        component="label"
        variant="caption"
        className={styles.unitLabel}
      >
        {label}
      </RobotoTypography>
      <FormControl fullWidth size="small">
        <Select
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          displayEmpty
          className={styles.smallFont}
        >
          <MenuItem value="" disabled className={styles.smallFont}>
            Select unit
          </MenuItem>
          <MenuItem value="deg_float" className={styles.smallFont}>
            Decimal degrees (float)
          </MenuItem>
          <MenuItem value="deg_int_1e7" className={styles.smallFont}>
            Integer degrees × 10⁻⁷
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
